'use client';

import * as a from "react";
import p from "../lib/IconBase.es.js";
import e from "../defs/WarningOctagon.es.js";
const n = a.forwardRef((a$1, r) => /* @__PURE__ */ a.createElement(p, { ref: r, ...a$1, weights: e }));
n.displayName = "WarningOctagonIcon";
const m = n;
export {
  m as WarningOctagon,
  n as WarningOctagonIcon
};
